import { render, staticRenderFns } from "./flowStatistics.vue?vue&type=template&id=d611f924&scoped=true"
import script from "./flowStatistics.vue?vue&type=script&lang=js"
export * from "./flowStatistics.vue?vue&type=script&lang=js"
import style0 from "./flowStatistics.vue?vue&type=style&index=0&id=d611f924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d611f924",
  null
  
)

export default component.exports